import { isPenaltyReconfirmed, type CancellationPenaltyFields } from '@bandido/shared/types';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

/** UTC matches the date-range filters; never render an unknown date as free. */
export function CancellationPenaltyLabel({ booking }: { booking: CancellationPenaltyFields }) {
  const { t, i18n } = useTranslation();
  const timing = booking.cancellationPenaltyTiming ?? 'unknown';
  const date = booking.cancellationPenaltyStartsAt ? new Date(booking.cancellationPenaltyStartsAt) : null;
  const validDate = date && Number.isFinite(date.getTime());
  return (
    <Typography variant="body2">
      {t('travelServices.bookingList.penalty.label')}:{' '}
      {timing === 'scheduled' && validDate
        ? `${date.toLocaleString(i18n.language, { timeZone: 'UTC', dateStyle: 'short', timeStyle: 'short' })} UTC`
        : t(`travelServices.bookingList.penalty.${timing === 'scheduled' ? 'unknown' : timing}`)}
      {isPenaltyReconfirmed(booking) && ` · ${t('penaltyReminders.reconfirmed')}`}
    </Typography>
  );
}
